(function () {
  function initThumbSlider(slider) {
    const list = slider.querySelector('ul.thumbnail-list');
    const prev = slider.querySelector('.slider-button--prev');
    const next = slider.querySelector('.slider-button--next');
    if (!list || !prev || !next) return;

    function getFit() {
      const first = list.querySelector('.thumbnail-list__item');
      if (!first) return 1;

      const itemW = first.getBoundingClientRect().width;
      const styles = getComputedStyle(list);
      const gap = parseFloat(styles.gap || styles.columnGap || '0') || 0;
      const viewportW = list.getBoundingClientRect().width;

      return Math.max(1, Math.floor((viewportW + gap) / (itemW + gap)));
    }

    function scrollByFit(dir) {
      const first = list.querySelector('.thumbnail-list__item');
      if (!first) return;

      const itemW = first.getBoundingClientRect().width;
      const styles = getComputedStyle(list);
      const gap = parseFloat(styles.gap || styles.columnGap || '0') || 0;

      const fit = getFit();
      const delta = (itemW + gap) * fit * dir;

      list.scrollBy({ left: delta, behavior: 'smooth' });
    }

    prev.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollByFit(-1);
    }, true);

    next.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollByFit(1);
    }, true);
  }

  function boot() {
    document.querySelectorAll('slider-component.thumbnail-slider').forEach(initThumbSlider);
  }

  document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', boot);
})();
